module.exports = __webpack_public_path__ + "img/9788964371794.543c2e9c.jpg";